import api from "pages/api/axiosInstance";
import type {
  ExamBaseResponse,
  ExamGateResponse,
  ExamType,
} from "./teacher/exam/types";

/**
 * 학생 검사 게이트 판정. 코드 입장이 필요한 할당 검사인지 조회한다.
 * `GET /app/exam/gate?examType&examRef`
 *
 * @param examType 검사 유형. OBJECTIVE 또는 ESSAY.
 * @param examRef OBJECTIVE면 chapterSetId, ESSAY면 essayChapterTemplateId.
 * @returns `ExamGateResponse`. `{ requiresCode, examId }`.
 *
 * ★ 학생 응답에 entryCode는 절대 포함되지 않는다.
 * SWR 훅이 아닌 1회성 함수. 진입 시점의 최신 판정이 필요하므로 캐시를 쓰지 않는다.
 */
export const getExamGate = async (
  examType: ExamType,
  examRef: number,
): Promise<ExamGateResponse> => {
  const res = await api.get<ExamBaseResponse<ExamGateResponse>>(
    "/app/exam/gate",
    { params: { examType, examRef } },
  );
  return res.data.result;
};
